module.exports = __webpack_public_path__ + "static/img/apple-laptop-notebook-office-39284.e39e8f37.jpg";